import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Modal, themes, activateTheme } from '../../canvasComponents/index';
// scss
import '../../css/components/PopUps/PopUps.scss';
// messages
import messages from './messages';

function UnibanPopUp({ open, closeUnibanPopUp }) {
  const [policyNumberCollected, setPolicyNumberCollected] = useState('XXXXXXXXX');
  useEffect(() => {
    const thePolicy = JSON.parse(window.sessionStorage.getItem('thePolicy'));
    if (thePolicy) {
      const { policyNumber } = thePolicy || null;
      if (policyNumber) {
        setPolicyNumberCollected(policyNumber);
      }
    }

    activateTheme(themes.sonnet);
  }, [open]);

  return (
    <Modal
      id="fatalityModal"
      isOpen={open}
      ariaHideApp={false}
      onRequestClose={() => closeUnibanPopUp()}
    >
      <div>
        <div className="pop-up-title">
          <FormattedMessage {...messages.title} />
        </div>
        <div className="pop-up-text margin-text-bottom">
          <FormattedMessage {...messages.text} />
          <a style={{ textDecoration: 'none' }} href="tel:1-844–766-6384">1-844–766-6384</a>
          <FormattedMessage {...messages.text2} />
          <br />
          <FormattedMessage
            {...messages.text3}
            values={{
              policyNumber: policyNumberCollected,
            }}
          />
          <br />
          <b><FormattedMessage {...messages.text4} /></b>
          <FormattedMessage {...messages.text5} />
        </div>
        <Button
          primary
          className="pop-up-btn"
          onClick={() => closeUnibanPopUp()}
        >
          <FormattedMessage {...messages.btn} />
        </Button>
      </div>
    </Modal>
  );
}

export default injectIntl(UnibanPopUp);
